import React from 'react'
import { List, Separator, Skeleton } from '@fs/zion-ui'
import AddDiscussionButton from '../../components/collaborate/AddDiscussionButton'
import SkeletonAnimationSyncDecorator from '../../../common/SkeletonAnimationSyncDecorator'

export function DiscussionsListLoading(): JSX.Element {
  return (
    <SkeletonAnimationSyncDecorator>
      <List>
        <Skeleton.ListItem hasSecondLine />
        <Skeleton.ListItem hasSecondLine />
        <Skeleton.ListItem hasSecondLine />
      </List>
    </SkeletonAnimationSyncDecorator>
  )
}

export default function DiscussionsLoading(): JSX.Element {
  return (
    <SkeletonAnimationSyncDecorator>
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <AddDiscussionButton disabled />
      <Separator size="nano" />
      <DiscussionsListLoading />
    </SkeletonAnimationSyncDecorator>
  )
}
